var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withTheme } from 'styled-components';
import { getColumnsWidthForBreakpoint } from '../helpers/grid';
import { Breakpoints } from '../helpers/breakpoint';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
import { ContentLayerV2Content, } from './content-layer-v2-content';
const animationClassName = 'animation';
const StyledScrollWrapper = styled.div.withConfig({ displayName: "StyledScrollWrapper", componentId: "sc-1tgic0h" }) `position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;-webkit-overflow-scrolling:touch;transition:${(props) => {
    const duration = props.theme.animation.duration.layer;
    const timingFunction = props.theme.animation.timingFunction.in;
    return `transform ${duration} ${timingFunction}`;
}};&.${animationClassName}-exit{transform:translateY(0);}&.${animationClassName}-enter,&.${animationClassName}-exit-active,&.${animationClassName}-exit-done{transform:translateY(100%);}&.${animationClassName}-enter-active{transform:translateY(0);}&.${animationClassName}-enter-done{transform:none;}`;
const StyledLayer = styled.div.withConfig({ displayName: "StyledLayer", componentId: "sc-15gz0d8" }) `height:auto;width:100%;max-width:${getColumnsWidthForBreakpoint(24, Breakpoints.b2560)};margin-top:${(props) => props.theme.size.dynamic0350};margin-bottom:${(props) => props.theme.size.dynamic0350};margin-right:auto;margin-left:auto;background-color:${({ theme }) => theme.colors.background.primary};pointer-events:auto;`;
function isHTMLElement(element) {
    return element.click !== undefined;
}
/*
    The StyledScrollWrapper needs to be as big as the screen to allow the scroll behaviour
    with empty space above the content. But this StyledScrollWrapper prevents click events from targeting
    the ShimLayer which should be a sibling of this layer.
    (This is only an issue in chrome: https://bugs.chromium.org/p/chromium/issues/detail?id=818444)
    This function allows us to have a scroll wrapper that is as big as the whole screen.
*/
function preventClickCapture(event) {
    const target = event.currentTarget;
    target.style.pointerEvents = 'none';
    const newTarget = document.elementFromPoint(event.clientX, event.clientY);
    if (newTarget && isHTMLElement(newTarget)) {
        newTarget.click();
    }
    target.style.pointerEvents = '';
}
function InternalContentLayer(props) {
    const { active, children, in: visible, onExited, scrollElementRef, withoutHeader, 'aria-labelledby': ariaLabelledBy } = props, rest = __rest(props, ["active", "children", "in", "onExited", "scrollElementRef", "withoutHeader", 'aria-labelledby']);
    const commonProps = getCommonProps(props);
    return (React.createElement(CSSTransition, { classNames: animationClassName, onExited: onExited, in: visible, timeout: parseInt(props.theme.animation.duration.layer || '0', 10) },
        React.createElement(StyledScrollWrapper, Object.assign({}, commonProps, { onClick: preventClickCapture, ref: scrollElementRef }),
            React.createElement(StyledLayer, Object.assign({}, rest, { role: "dialog", "aria-modal": active, "aria-labelledby": ariaLabelledBy, 
                // The propagation of the events needs to be stopped here to prevent the
                // StyledScrollWrapper to detect a click for child elements
                onClick: (event) => event.stopPropagation() }), withoutHeader ? (children) : (React.createElement(ContentLayerV2Content, { contentId: ariaLabelledBy, closeButtonLabel: props.closeButtonLabel, contentHeadline: props.contentHeadline, onClose: props.onClose, disableDefaultPadding: props.disableDefaultPadding }, children))))));
}
export const ContentLayerV2 = withTheme(InternalContentLayer);
export * from './content-layer-v2-content';
